import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const AlertLogsService = {
    loadAlertLogsWPaging,
    modifyAlertLogSeen
}

function loadAlertLogsWPaging(clientID, index, number) {
    const query = `{
      alertLogsWPaging (
          clientID: "${clientID}",
          index: ${index},
          number: ${number}
      ) {
          lastPage,
          alertLogs {
              id
              message
              source
              date
              seen
          },
          nbPages
      }
  }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.alertLogsWPaging);
    });
}

function modifyAlertLogSeen(clientID, id, seen) {
    const query = `mutation{
      modifyAlertLogSeen (
          clientID: "${clientID}",
          id: "${id}",
          seen: ${seen}
      ) {
          id
      }
  }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.modifyAlertLogSeen);
    });
}